import fieldMixin from "@/mixins/field"
import type { CustomEvent } from "@/types/api/event"

export default fieldMixin.extend({
  props: {
    min: { type: String, default: "" },
    max: { type: String, default: "" },
    dateDisabled: { type: Function, default: null },
    checkAge: { type: Boolean, default: false },
    event: { type: Object as VuePropType<CustomEvent | null>, default: null },
    required: { type: Boolean, default: false },
    status: { type: String, default: "" },
  },

  computed: {
    now (): number {
      return Date.now()
    },

    minTs (): number {
      const { min } = this
      if (!min) return 0
      return new Date(min).getTime()
    },

    maxTs (): number {
      const { max } = this
      if (!max) return 0
      return new Date(max).getTime()
    },

    statusMeta (): NonNullable<CustomEvent["statuses"]>[number] | undefined {
      const meta = this.event?.statuses?.find(s => this.status === s.id)
      if (meta) return meta
      return this.event?.statuses?.find(s => s.default)
    },

    validationRules (): VeeValidateRules {
      const rules: VeeValidateRules = {
        required: this.required || false,
      }

      const { minTs, maxTs } = this
      if (minTs) rules.min_date = minTs
      if (maxTs) rules.max_date = maxTs
      if (this.checkAge) rules.valid_age = {
        event: this.event,
        status: this.statusMeta,
      }

      return rules
    },

    pickerOptions (): Record<string, any> {
      const { minTs, maxTs, dateDisabled } = this
      return {
        disabledDate (time: Date): boolean {
          const ts = time.getTime()
          return (minTs && ts < minTs) ||
            (maxTs && ts > maxTs) ||
            (dateDisabled && dateDisabled(ts))
        },
        firstDayOfWeek: 1,
      }
    },
  },
})
